import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MitsIconModule } from 'src/packages/shared-ui';
import { DefaultValueComponent } from './default-value/default-value.component';
import { NumberElementComponent } from './number-element/number-element.component';
import { SelectElementComponent } from './select-element/select-element.component';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, MitsIconModule],
  declarations: [
    DefaultValueComponent,
    NumberElementComponent,
    SelectElementComponent,
  ],
  entryComponents: [],
  exports: [
    DefaultValueComponent,
    NumberElementComponent,
    SelectElementComponent,
  ],
  providers: [],
})
export class ChecklistModuleSettingsModule {}
